<div class="container-fluid">
  <div class="row">
    <div class="col-md-12 mb-2">
      <div class="breadcrumb-title mb-2 mt-md-0">
        <div class="d-flex align-items-center gap-2 ms-md-2 ms-0">
          <mat-icon class="text-primary">group</mat-icon>
          <h5 class="mt-2">
            {{ applicationName }} {{ "applicationUsers.title" | translate }}
          </h5>
        </div>
      </div>

      <div class="col-md-12 mt-3">
        <mat-card appearance="outlined" class="pb-4 px-2">
          <mat-card-content class="pb-4">
            <div class="row align-items-center compact-inputs dropdown-pd-none">
              <!-- Search Input -->
              <div class="col-xxl-3 col-xl-4 col-md-10 col-sm-12 mb-2 px-1">
                <div class="d-flex justify-content-start align-items-center">
                  <div class="flex-grow-1">
                    <mat-form-field
                      appearance="outline"
                      subscriptSizing="dynamic"
                      class="w-100"
                    >
                      <input
                        matInput
                        type="text"
                        [(ngModel)]="searchText"
                        [placeholder]="
                          'applicationUsers.search.placeholder' | translate
                        "
                      />
                    </mat-form-field>
                  </div>
                  <button
                    mat-icon-button
                    class="icon-center icon-clean ms-1"
                    [matTooltip]="
                      'applicationUsers.search.placeholder' | translate
                    "
                    matTooltipPosition="above"
                  >
                    <mat-icon class="text-secondary icon-compact"
                      >info</mat-icon
                    >
                  </button>
                </div>
              </div>

              <!-- Role Dropdown -->
              <div class="col-xxl-3 col-xl-4 col-md-10 col-sm-12 mb-2 px-1">
                <div class="d-flex justify-content-start align-items-center">
                  <div class="flex-grow-1">
                    <mat-form-field
                      appearance="outline"
                      subscriptSizing="dynamic"
                      class="w-100"
                    >
                      <mat-select
                        [(ngModel)]="selectedRoleId"
                        id="selectedRoleId"
                        name="selectedRoleId"
                      >
                        <mat-option value="">{{
                          "applicationUsers.search.rolePlaceholder" | translate
                        }}</mat-option>
                        <mat-option
                          *ngFor="let c of applicationRoles"
                          [value]="c['id']"
                          >{{ c["name"] }}</mat-option
                        >
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <button
                    mat-icon-button
                    class="icon-center icon-clean ms-1"
                    [matTooltip]="
                      'applicationUsers.search.rolePlaceholder' | translate
                    "
                    matTooltipPosition="above"
                  >
                    <mat-icon class="text-secondary icon-compact"
                      >info</mat-icon
                    >
                  </button>
                </div>
              </div>

              <!-- Status Dropdown -->
              <div class="col-xxl-3 col-xl-4 col-md-10 col-sm-12 mb-2 px-1">
                <div class="d-flex justify-content-start align-items-center">
                  <div class="flex-grow-1">
                    <mat-form-field
                      appearance="outline"
                      subscriptSizing="dynamic"
                      class="w-100"
                    >
                      <mat-select [(ngModel)]="selectedStatus">
                        <mat-option value="">{{
                          "applicationUsers.search.statusPlaceholder"
                            | translate
                        }}</mat-option>
                        <mat-option value="Accept">{{
                          "applicationUsers.table.statusOptions.accept"
                            | translate
                        }}</mat-option>
                        <mat-option value="Reject">{{
                          "applicationUsers.table.statusOptions.reject"
                            | translate
                        }}</mat-option>
                        <mat-option value="Pending">{{
                          "applicationUsers.table.statusOptions.pending"
                            | translate
                        }}</mat-option>
                        <mat-option value="Cancel">{{
                          "applicationUsers.table.statusOptions.cancel"
                            | translate
                        }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <button
                    mat-icon-button
                    class="icon-center icon-clean ms-1"
                    [matTooltip]="
                      'applicationUsers.search.statusPlaceholder' | translate
                    "
                    matTooltipPosition="above"
                  >
                    <mat-icon class="text-secondary icon-compact"
                      >info</mat-icon
                    >
                  </button>
                </div>
              </div>

              <!-- Search Button -->
              <div class="col-auto mb-2 px-1">
                <button
                  mat-stroked-button
                  color="primary"
                  type="button"
                  (click)="searchUsers()"
                >
                  <mat-icon class="icon-compact">search</mat-icon>
                  {{ "applicationUsers.search.buttons.search" | translate }}
                </button>
              </div>

              <!-- Reset Button -->
              <div class="col-auto mb-2 px-1">
                <button
                  mat-stroked-button
                  color="primary"
                  type="button"
                  (click)="search(); resetFilters()"
                >
                  <i class="fa fa-eraser"></i>
                  <span class="ms-2">{{
                    "applicationUsers.search.buttons.reset" | translate
                  }}</span>
                </button>
              </div>

              <!-- Invite Button — user-side: canCreate() guard -->
              <div class="col-auto mb-2 px-1">
                <button
                  *ngIf="canCreate()"
                  mat-stroked-button
                  color="primary"
                  type="button"
                  data-bs-toggle="modal"
                  data-bs-target="#inviteModal"
                >
                  <mat-icon class="icon-compact">mail_outline</mat-icon>
                  {{ "applicationUsers.search.buttons.invite" | translate }}
                </button>
              </div>

              <!-- Bulk Upload Button — user-side: canCreate() guard -->
              <div class="col-auto mb-2 px-1">
                <button
                  *ngIf="canCreate()"
                  mat-stroked-button
                  color="primary"
                  type="button"
                  data-bs-toggle="modal"
                  data-bs-target="#uploadModal"
                >
                  <mat-icon class="icon-compact">upload</mat-icon>
                  {{ "applicationUsers.search.buttons.bulkUpload" | translate }}
                </button>
              </div>

              <!-- Bulk User List Button -->
              <div class="col-auto mb-2 px-1">
                <button
                  mat-stroked-button
                  color="primary"
                  [title]="'APPLICATIONS.USERS' | translate"
                  [routerLink]="['/usecaseDatabase', appId]"
                  [queryParams]="{ fromUserButton: true }"
                >
                  <mat-icon class="icon-compact">group</mat-icon>
                  {{
                    "applicationUsers.search.buttons.bulkUserList" | translate
                  }}
                </button>
              </div>
            </div>

            <!-- Table — user-side: canRead() guard -->
            <div class="row">
              <div class="col-12 px-1">
                <div *ngIf="canRead()" class="table-container mt-2">
                  <div class="table-responsive table-scrollable">
                    <table
                      class="table table-hover table-bordered table-sticky-header"
                    >
                      <thead>
                        <tr>
                          <th>
                            {{
                              "applicationUsers.table.headers.sno" | translate
                            }}
                          </th>
                          <th>
                            {{
                              "applicationUsers.table.headers.name" | translate
                            }}
                          </th>
                          <th>
                            {{
                              "applicationUsers.table.headers.role" | translate
                            }}
                          </th>
                          <th>
                            {{
                              "applicationUsers.table.headers.status"
                                | translate
                            }}
                          </th>
                          <th>
                            {{
                              "applicationUsers.table.headers.action"
                                | translate
                            }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let e of form.list; let i = index">
                          <td class="text-center" style="width: 5%">
                            {{ pageIndex(i) }}
                          </td>
                          <td>{{ e.email }}</td>
                          <td class="fw-semibold text-dark">
                            {{ e.applicationRoleName }}
                          </td>

                          <!-- Status: non-Accept — plain text -->
                          <td *ngIf="e.status !== 'Accept'" style="width: 15%">
                            <span class="ms-1"> {{ e.status }}</span>
                          </td>

                          <!-- Status: Accept — user-side: canUpdate() guard on dropdown -->
                          <td *ngIf="e.status === 'Accept'" style="width: 15%">
                            <mat-form-field
                              *ngIf="canUpdate()"
                              appearance="outline"
                              subscriptSizing="dynamic"
                              class="compact-inputs w-100"
                            >
                              <mat-select
                                [(ngModel)]="e.status"
                                (selectionChange)="changeStatus(e.id, e.status)"
                              >
                                <mat-option value="" disabled>{{
                                  "applicationUsers.table.statusOptions.select"
                                    | translate
                                }}</mat-option>
                                <mat-option value="Accept">{{
                                  "applicationUsers.table.statusOptions.accept"
                                    | translate
                                }}</mat-option>
                                <mat-option value="Reject">{{
                                  "applicationUsers.table.statusOptions.reject"
                                    | translate
                                }}</mat-option>
                                <mat-option value="Pending">{{
                                  "applicationUsers.table.statusOptions.pending"
                                    | translate
                                }}</mat-option>
                                <mat-option value="Cancel">{{
                                  "applicationUsers.table.statusOptions.cancel"
                                    | translate
                                }}</mat-option>
                              </mat-select>
                            </mat-form-field>
                            <!-- Show plain text if canUpdate() is false -->
                            <span *ngIf="!canUpdate()">{{ e.status }}</span>
                          </td>

                          <!-- Action — user-side: canDelete() guard -->
                          <td class="text-center" style="width: 10%">
                            <button
                              *ngIf="canDelete()"
                              mat-stroked-button
                              color="warn"
                              type="button"
                              [matTooltip]="
                                'applicationUsers.table.actions.delete'
                                  | translate
                              "
                              (click)="delete(e.id)"
                              class="icon-center icon-width"
                            >
                              <mat-icon class="icon-compact">delete</mat-icon>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </mat-card-content>

          <!-- Pagination / Footer Component -->
          <app-list-header [$parent]="getSelf()"></app-list-header>
        </mat-card>
      </div>
    </div>
  </div>

  <!-- Upload CSV Modal -->
  <div
    class="modal fade"
    id="uploadModal"
    tabindex="-1"
    aria-labelledby="uploadModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="uploadModalLabel">
            {{ "applicationUsers.modals.upload.title" | translate }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            (click)="resetForm()"
          ></button>
        </div>

        <div class="modal-body compact-inputs dropdown-pd-none">
          <p *ngIf="form['error'] == false && form['message']">
            <app-ncs-alert [message]="form['message']" type="success" />
          </p>
          <p *ngIf="form['error'] == true && form['message']">
            <app-ncs-alert [message]="form['message']" type="danger" />
          </p>
          <p *ngIf="form['searchError'] == false && form['searchMessage']">
            <app-ncs-alert [message]="form['searchMessage']" type="success" />
          </p>
          <p *ngIf="form['searchError'] == true && form['searchMessage']">
            <app-ncs-alert [message]="form['searchMessage']" type="danger" />
          </p>

          <!-- Select Role -->
          <div class="mb-3 d-flex align-items-center">
            <mat-label class="me-2 mb-0" style="width: 100px">
              {{
                "applicationUsers.modals.upload.labels.selectRole" | translate
              }}
            </mat-label>
            <mat-form-field appearance="outline" style="width: 280px">
              <mat-select
                id="applicationRoleInModal"
                name="applicationRoleInModal"
                [(ngModel)]="form.data['applicationRoleId']"
                [placeholder]="
                  'applicationUsers.search.rolePlaceholder' | translate
                "
                required
              >
                <mat-option disabled selected value="undefined">
                  {{ "applicationUsers.search.rolePlaceholder" | translate }}
                </mat-option>
                <mat-option
                  *ngFor="let c of applicationRoles"
                  [value]="c['id']"
                  >{{ c["name"] }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Select CSV -->
          <div class="mb-3 d-flex align-items-center">
            <mat-label class="me-2 mb-0" style="width: 100px">
              {{
                "applicationUsers.modals.upload.labels.selectCSV" | translate
              }}
            </mat-label>
            <mat-form-field appearance="outline" style="width: 280px">
              <!-- Hidden real file input -->
              <input
                type="file"
                hidden
                #fileInput
                id="csvFile"
                (change)="confirmUpload($event)"
                accept=".csv"
                [disabled]="
                  !form.data['applicationRoleId'] ||
                  form.data['applicationRoleId'] === 'undefined'
                "
              />
              <input
                matInput
                [value]="selectedCsvFile ? selectedCsvFile.name : ''"
                [placeholder]="'Remains.SELECT_FILE' | translate"
                readonly
                [disabled]="
                  !form.data['applicationRoleId'] ||
                  form.data['applicationRoleId'] === 'undefined'
                "
                (click)="fileInput.click()"
                style="cursor: pointer"
              />
              <button
                mat-icon-button
                matSuffix
                type="button"
                class="icon-pd-none"
                [disabled]="
                  !form.data['applicationRoleId'] ||
                  form.data['applicationRoleId'] === 'undefined'
                "
                (click)="fileInput.click(); $event.stopPropagation()"
              >
                <mat-icon class="icon-compact">attach_file</mat-icon>
              </button>
            </mat-form-field>
          </div>

          <!-- Sample CSV Download -->
          <div class="mb-3 d-flex align-items-center">
            <mat-label class="me-2 mb-0" style="width: 100px">
              {{
                "applicationUsers.modals.upload.labels.sampleFile" | translate
              }}
            </mat-label>
            <button
              mat-stroked-button
              color="primary"
              [title]="'COMMON.Download' | translate"
              (click)="uploadBulkUserSampleCsv()"
            >
              <mat-icon>download</mat-icon>
              {{ "COMMON.Download" | translate }}
            </button>
          </div>
        </div>

        <div class="modal-footer">
          <button
            mat-stroked-button
            color="primary"
            class="btn-sm me-1"
            (click)="onCsvFileUpload()"
            [disabled]="
              !form.data['applicationRoleId'] ||
              form.data['applicationRoleId'] === 'undefined' ||
              !selectedCsvFile
            "
          >
            <mat-icon>upload</mat-icon>
            {{ "COMMON.UPLOAD" | translate }}
          </button>
          <button
            mat-stroked-button
            color="warn"
            class="btn-sm"
            data-bs-dismiss="modal"
            [title]="'COMMON.CLOSE' | translate"
            (click)="resetForm()"
          >
            <mat-icon>close</mat-icon>
            {{ "COMMON.CLOSE" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Invite Modal -->
  <div class="modal fade" id="inviteModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ "applicationUsers.modals.invite.title" | translate }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            (click)="resetForm(); resetselectemails()"
          ></button>
        </div>

        <div class="modal-body">
          <p *ngIf="form['message']">
            <app-ncs-alert
              [message]="form['message']"
              [type]="form['error'] ? 'danger' : 'success'"
            ></app-ncs-alert>
          </p>

          <form #uiForm="ngForm">
            <div class="mb-3 d-flex align-items-center">
              <label class="form-label me-2 mb-0" style="width: 100px">
                {{
                  "applicationUsers.modals.invite.labels.selectRole" | translate
                }}
              </label>
              <mat-form-field
                appearance="outline"
                style="width: 280px"
                subscriptSizing="dynamic"
              >
                <mat-select
                  name="applicationRoleInModal"
                  [(ngModel)]="form.data['applicationRoleId']"
                  [placeholder]="
                    'applicationUsers.search.rolePlaceholder' | translate
                  "
                  required
                >
                  <mat-option [value]="undefined" disabled>
                    {{ "applicationUsers.search.rolePlaceholder" | translate }}
                  </mat-option>
                  <mat-option *ngFor="let c of applicationRoles" [value]="c.id">
                    {{ c.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="mb-3 d-flex align-items-start flex-column">
              <div class="d-flex align-items-center">
                <label class="form-label me-2 mb-0" style="width: 100px">
                  {{
                    "applicationUsers.modals.invite.labels.email" | translate
                  }}
                </label>
                <mat-form-field
                  appearance="outline"
                  style="width: 280px"
                  subscriptSizing="dynamic"
                >
                  <input
                    matInput
                    type="email"
                    name="emailInput"
                    placeholder="{{'Remains.Enter_Email_Enter' | translate}}"
                    [(ngModel)]="emailInput"
                    (keydown.enter)="addEmail($event)"
                    (input)="clearEmailError()"
                  />
                </mat-form-field>
              </div>

              <div class="mt-2 d-flex flex-wrap" style="padding-left: 108px">
                <span
                  *ngFor="let e of emailList; let i = index"
                  class="badge bg-primary me-1 mb-1 p-2"
                >
                  {{ e }}
                  <i
                    class="fa fa-times ms-2"
                    (click)="removeEmail(i)"
                    style="cursor: pointer"
                  ></i>
                </span>
              </div>

              <div
                *ngIf="emailError"
                class="text-danger mt-1"
                style="padding-left: 108px; font-size: 12px"
              >
                {{ emailError }}
              </div>
            </div>
          </form>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            mat-stroked-button
            color="primary"
            class="me-2"
            (click)="save()"
            [disabled]="
              !form.data['applicationRoleId'] ||
              (emailList.length === 0 && !emailInput)
            "
          >
            <mat-icon>mail_outline</mat-icon>
            {{ "COMMON.INVITE" | translate }}
          </button>
          <button
            type="button"
            mat-stroked-button
            color="warn"
            data-bs-dismiss="modal"
            (click)="resetForm(); resetselectemails()"
          >
            <mat-icon>close</mat-icon>
            {{ "COMMON.CLOSE" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Error Modal -->
  <div
    class="modal fade"
    id="errorModal"
    tabindex="-1"
    aria-labelledby="errorModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="errorModalLabel">
            {{'Remains.Upload_Errors' | translate}}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="table-container">
            <div class="table-responsive table-scrollable">
              <table
                class="table table-hover table-bordered table-sticky-header"
              >
                <thead>
                  <tr>
                    <th class="text-center">{{'COMMON.ROW_NUMBER' | translate}}</th>
                    <th>{{'COMMON.ER_MSG' | translate}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let error of errorList">
                    <td class="text-center">{{ error.rowNumber }}</td>
                    <td>{{ error.message }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            mat-stroked-button
            color="warn"
            type="button"
            data-bs-dismiss="modal"
          >
            <mat-icon>close</mat-icon> {{'COMMON.CLOSE' | translate}}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
